import { default as _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta } from "/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta } from "/home/forge/dreamjobs.hu/pages/berkalkulator.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta } from "/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta } from "/home/forge/dreamjobs.hu/pages/blog/index.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta } from "/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta } from "/home/forge/dreamjobs.hu/pages/business/prices.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta } from "/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta } from "/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta } from "/home/forge/dreamjobs.hu/pages/companies.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta } from "/home/forge/dreamjobs.hu/pages/company/[slug].vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta } from "/home/forge/dreamjobs.hu/pages/contact-us.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta } from "/home/forge/dreamjobs.hu/pages/cv-generator.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta } from "/home/forge/dreamjobs.hu/pages/employer-branding.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta } from "/home/forge/dreamjobs.hu/pages/fizetesek.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta } from "/home/forge/dreamjobs.hu/pages/followed-companies.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta } from "/home/forge/dreamjobs.hu/pages/index.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta } from "/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta } from "/home/forge/dreamjobs.hu/pages/jobnotification.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta } from "/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta } from "/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta } from "/home/forge/dreamjobs.hu/pages/jobs/index.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta } from "/home/forge/dreamjobs.hu/pages/junior-jobs.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta } from "/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta } from "/home/forge/dreamjobs.hu/pages/locations.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta } from "/home/forge/dreamjobs.hu/pages/login/index.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta } from "/home/forge/dreamjobs.hu/pages/login/otp.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta } from "/home/forge/dreamjobs.hu/pages/maintenance.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta } from "/home/forge/dreamjobs.hu/pages/my-applications.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta } from "/home/forge/dreamjobs.hu/pages/podcasts.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta } from "/home/forge/dreamjobs.hu/pages/premium-toborzas.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta } from "/home/forge/dreamjobs.hu/pages/registration.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta } from "/home/forge/dreamjobs.hu/pages/reset-password.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta } from "/home/forge/dreamjobs.hu/pages/salarycalculator.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta } from "/home/forge/dreamjobs.hu/pages/saved-jobs.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta } from "/home/forge/dreamjobs.hu/pages/social-login-success.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta } from "/home/forge/dreamjobs.hu/pages/social-registration.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta } from "/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta } from "/home/forge/dreamjobs.hu/pages/szmd/rating.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta } from "/home/forge/dreamjobs.hu/pages/unsubscribe.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta } from "/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta } from "/home/forge/dreamjobs.hu/pages/user/account.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta } from "/home/forge/dreamjobs.hu/pages/user/change-password.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta } from "/home/forge/dreamjobs.hu/pages/user/cv.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta } from "/home/forge/dreamjobs.hu/pages/user/linkedin.vue?macro=true";
import { default as _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta } from "/home/forge/dreamjobs.hu/pages/user/notifications.vue?macro=true";
export default [
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.name ?? "apply-company_slug-slug",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.path ?? "/apply/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.name ?? "apply-company_slug-slug___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.path ?? "/hu/apply/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.name ?? "apply-company_slug-slug___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.path ?? "/ro/apply/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.name ?? "apply-company_slug-slug___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.path ?? "/en/apply/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47apply_47_91company_slug_93_47_91slug_93_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/apply/[company_slug]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.name ?? "berkalkulator",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.path ?? "/berkalkulator",
    file: "/home/forge/dreamjobs.hu/pages/berkalkulator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/berkalkulator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.name ?? "berkalkulator___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.path ?? "/hu/berkalkulator",
    file: "/home/forge/dreamjobs.hu/pages/berkalkulator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/berkalkulator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.name ?? "berkalkulator___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.path ?? "/ro/berkalkulator",
    file: "/home/forge/dreamjobs.hu/pages/berkalkulator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/berkalkulator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.name ?? "berkalkulator___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.path ?? "/en/berkalkulator",
    file: "/home/forge/dreamjobs.hu/pages/berkalkulator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47berkalkulator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/berkalkulator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.name ?? "blog-blog_slug",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.path ?? "/blog/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.name ?? "blog-blog_slug___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.path ?? "/hu/blog/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.name ?? "blog-blog_slug___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.path ?? "/ro/blog/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.name ?? "blog-blog_slug___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.path ?? "/en/blog/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.name ?? "blog",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.path ?? "/blog",
    file: "/home/forge/dreamjobs.hu/pages/blog/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.name ?? "blog___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.path ?? "/hu/blog",
    file: "/home/forge/dreamjobs.hu/pages/blog/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.name ?? "blog___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.path ?? "/ro/blog",
    file: "/home/forge/dreamjobs.hu/pages/blog/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.name ?? "blog___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.path ?? "/en/blog",
    file: "/home/forge/dreamjobs.hu/pages/blog/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.name ?? "blog-post-blog_slug",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.path ?? "/blog/post/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.name ?? "blog-post-blog_slug___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.path ?? "/hu/blog/post/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.name ?? "blog-post-blog_slug___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.path ?? "/ro/blog/post/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.name ?? "blog-post-blog_slug___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.path ?? "/en/blog/post/:blog_slug",
    file: "/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47blog_47post_47_91blog_slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/blog/post/[blog_slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.name ?? "business-prices",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.path ?? "/business/prices",
    file: "/home/forge/dreamjobs.hu/pages/business/prices.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/business/prices.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.name ?? "business-prices___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.path ?? "/hu/business/prices",
    file: "/home/forge/dreamjobs.hu/pages/business/prices.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/business/prices.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.name ?? "business-prices___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.path ?? "/ro/business/prices",
    file: "/home/forge/dreamjobs.hu/pages/business/prices.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/business/prices.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.name ?? "business-prices___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.path ?? "/en/business/prices",
    file: "/home/forge/dreamjobs.hu/pages/business/prices.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47business_47prices_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/business/prices.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.name ?? "calculatorsalariu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.path ?? "/calculatorsalariu",
    file: "/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.name ?? "calculatorsalariu___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.path ?? "/hu/calculatorsalariu",
    file: "/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.name ?? "calculatorsalariu___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.path ?? "/ro/calculatorsalariu",
    file: "/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.name ?? "calculatorsalariu___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.path ?? "/en/calculatorsalariu",
    file: "/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47calculatorsalariu_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/calculatorsalariu.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.name ?? "candidate-shortlist",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.path ?? "/candidate-shortlist",
    file: "/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.name ?? "candidate-shortlist___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.path ?? "/hu/candidate-shortlist",
    file: "/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.name ?? "candidate-shortlist___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.path ?? "/ro/candidate-shortlist",
    file: "/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.name ?? "candidate-shortlist___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.path ?? "/en/candidate-shortlist",
    file: "/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47candidate_45shortlist_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/candidate-shortlist.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.name ?? "companies",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.path ?? "/companies",
    file: "/home/forge/dreamjobs.hu/pages/companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.name ?? "companies___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.path ?? "/hu/companies",
    file: "/home/forge/dreamjobs.hu/pages/companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.name ?? "companies___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.path ?? "/ro/companies",
    file: "/home/forge/dreamjobs.hu/pages/companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.name ?? "companies___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.path ?? "/en/companies",
    file: "/home/forge/dreamjobs.hu/pages/companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.name ?? "company-slug",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.path ?? "/company/:slug",
    file: "/home/forge/dreamjobs.hu/pages/company/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/company/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.name ?? "company-slug___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.path ?? "/hu/company/:slug",
    file: "/home/forge/dreamjobs.hu/pages/company/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/company/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.name ?? "company-slug___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.path ?? "/ro/company/:slug",
    file: "/home/forge/dreamjobs.hu/pages/company/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/company/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.name ?? "company-slug___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.path ?? "/en/company/:slug",
    file: "/home/forge/dreamjobs.hu/pages/company/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47company_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/company/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.name ?? "contact-us",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.path ?? "/contact-us",
    file: "/home/forge/dreamjobs.hu/pages/contact-us.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.name ?? "contact-us___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.path ?? "/hu/contact-us",
    file: "/home/forge/dreamjobs.hu/pages/contact-us.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.name ?? "contact-us___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.path ?? "/ro/contact-us",
    file: "/home/forge/dreamjobs.hu/pages/contact-us.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.name ?? "contact-us___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.path ?? "/en/contact-us",
    file: "/home/forge/dreamjobs.hu/pages/contact-us.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47contact_45us_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.name ?? "cv-generator",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.path ?? "/cv-generator",
    file: "/home/forge/dreamjobs.hu/pages/cv-generator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/cv-generator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.name ?? "cv-generator___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.path ?? "/hu/cv-generator",
    file: "/home/forge/dreamjobs.hu/pages/cv-generator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/cv-generator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.name ?? "cv-generator___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.path ?? "/ro/cv-generator",
    file: "/home/forge/dreamjobs.hu/pages/cv-generator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/cv-generator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.name ?? "cv-generator___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.path ?? "/en/cv-generator",
    file: "/home/forge/dreamjobs.hu/pages/cv-generator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47cv_45generator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/cv-generator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.name ?? "employer-branding",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.path ?? "/employer-branding",
    file: "/home/forge/dreamjobs.hu/pages/employer-branding.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/employer-branding.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.name ?? "employer-branding___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.path ?? "/hu/employer-branding",
    file: "/home/forge/dreamjobs.hu/pages/employer-branding.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/employer-branding.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.name ?? "employer-branding___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.path ?? "/ro/employer-branding",
    file: "/home/forge/dreamjobs.hu/pages/employer-branding.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/employer-branding.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.name ?? "employer-branding___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.path ?? "/en/employer-branding",
    file: "/home/forge/dreamjobs.hu/pages/employer-branding.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47employer_45branding_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/employer-branding.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.name ?? "fizetesek",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.path ?? "/fizetesek",
    file: "/home/forge/dreamjobs.hu/pages/fizetesek.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/fizetesek.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.name ?? "fizetesek___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.path ?? "/hu/fizetesek",
    file: "/home/forge/dreamjobs.hu/pages/fizetesek.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/fizetesek.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.name ?? "fizetesek___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.path ?? "/ro/fizetesek",
    file: "/home/forge/dreamjobs.hu/pages/fizetesek.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/fizetesek.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.name ?? "fizetesek___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.path ?? "/en/fizetesek",
    file: "/home/forge/dreamjobs.hu/pages/fizetesek.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47fizetesek_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/fizetesek.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.name ?? "followed-companies",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.path ?? "/followed-companies",
    file: "/home/forge/dreamjobs.hu/pages/followed-companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/followed-companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.name ?? "followed-companies___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.path ?? "/hu/followed-companies",
    file: "/home/forge/dreamjobs.hu/pages/followed-companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/followed-companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.name ?? "followed-companies___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.path ?? "/ro/followed-companies",
    file: "/home/forge/dreamjobs.hu/pages/followed-companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/followed-companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.name ?? "followed-companies___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.path ?? "/en/followed-companies",
    file: "/home/forge/dreamjobs.hu/pages/followed-companies.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47followed_45companies_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/followed-companies.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.name ?? "index",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.path ?? "/",
    file: "/home/forge/dreamjobs.hu/pages/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.name ?? "index___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.path ?? "/hu",
    file: "/home/forge/dreamjobs.hu/pages/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.name ?? "index___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.path ?? "/ro",
    file: "/home/forge/dreamjobs.hu/pages/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.name ?? "index___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.path ?? "/en",
    file: "/home/forge/dreamjobs.hu/pages/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.name ?? "job-company_slug-slug",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.path ?? "/job/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.name ?? "job-company_slug-slug___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.path ?? "/hu/job/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.name ?? "job-company_slug-slug___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.path ?? "/ro/job/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.name ?? "job-company_slug-slug___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.path ?? "/en/job/:company_slug/:slug",
    file: "/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47job_47_91company_slug_93_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/job/[company_slug]/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.name ?? "jobnotification",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.path ?? "/jobnotification",
    file: "/home/forge/dreamjobs.hu/pages/jobnotification.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobnotification.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.name ?? "jobnotification___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.path ?? "/hu/jobnotification",
    file: "/home/forge/dreamjobs.hu/pages/jobnotification.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobnotification.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.name ?? "jobnotification___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.path ?? "/ro/jobnotification",
    file: "/home/forge/dreamjobs.hu/pages/jobnotification.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobnotification.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.name ?? "jobnotification___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.path ?? "/en/jobnotification",
    file: "/home/forge/dreamjobs.hu/pages/jobnotification.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobnotification_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobnotification.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.name ?? "jobs-citySlug",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.path ?? "/jobs/:citySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.name ?? "jobs-citySlug___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.path ?? "/hu/jobs/:citySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.name ?? "jobs-citySlug___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.path ?? "/ro/jobs/:citySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.name ?? "jobs-citySlug___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.path ?? "/en/jobs/:citySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47_91citySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/[citySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.name ?? "jobs-county-countySlug",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.path ?? "/jobs/county/:countySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.name ?? "jobs-county-countySlug___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.path ?? "/hu/jobs/county/:countySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.name ?? "jobs-county-countySlug___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.path ?? "/ro/jobs/county/:countySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.name ?? "jobs-county-countySlug___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.path ?? "/en/jobs/county/:countySlug",
    file: "/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47county_47_91countySlug_93_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/county/[countySlug].vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.name ?? "jobs",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.path ?? "/jobs",
    file: "/home/forge/dreamjobs.hu/pages/jobs/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.name ?? "jobs___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.path ?? "/hu/jobs",
    file: "/home/forge/dreamjobs.hu/pages/jobs/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.name ?? "jobs___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.path ?? "/ro/jobs",
    file: "/home/forge/dreamjobs.hu/pages/jobs/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.name ?? "jobs___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.path ?? "/en/jobs",
    file: "/home/forge/dreamjobs.hu/pages/jobs/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47jobs_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.name ?? "junior-jobs",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.path ?? "/junior-jobs",
    file: "/home/forge/dreamjobs.hu/pages/junior-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/junior-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.name ?? "junior-jobs___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.path ?? "/hu/junior-jobs",
    file: "/home/forge/dreamjobs.hu/pages/junior-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/junior-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.name ?? "junior-jobs___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.path ?? "/ro/junior-jobs",
    file: "/home/forge/dreamjobs.hu/pages/junior-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/junior-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.name ?? "junior-jobs___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.path ?? "/en/junior-jobs",
    file: "/home/forge/dreamjobs.hu/pages/junior-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47junior_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/junior-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.name ?? "list-jobs-big-data-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.path ?? "/list/jobs/big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.name ?? "list-jobs-big-data-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.path ?? "/hu/list/jobs/big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.name ?? "list-jobs-big-data-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.path ?? "/ro/list/jobs/big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.name ?? "list-jobs-big-data-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.path ?? "/en/list/jobs/big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.name ?? "list-jobs-diak-es-gyakornoki-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.path ?? "/list/jobs/diak-es-gyakornoki-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.name ?? "list-jobs-diak-es-gyakornoki-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.path ?? "/hu/list/jobs/diak-es-gyakornoki-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.name ?? "list-jobs-diak-es-gyakornoki-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.path ?? "/ro/list/jobs/diak-es-gyakornoki-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.name ?? "list-jobs-diak-es-gyakornoki-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.path ?? "/en/list/jobs/diak-es-gyakornoki-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47diak_45es_45gyakornoki_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/diak-es-gyakornoki-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.name ?? "list-jobs-ertekesitesi-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.path ?? "/list/jobs/ertekesitesi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.name ?? "list-jobs-ertekesitesi-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.path ?? "/hu/list/jobs/ertekesitesi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.name ?? "list-jobs-ertekesitesi-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.path ?? "/ro/list/jobs/ertekesitesi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.name ?? "list-jobs-ertekesitesi-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.path ?? "/en/list/jobs/ertekesitesi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47ertekesitesi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/ertekesitesi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.name ?? "list-jobs-irodai-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.path ?? "/list/jobs/irodai-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.name ?? "list-jobs-irodai-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.path ?? "/hu/list/jobs/irodai-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.name ?? "list-jobs-irodai-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.path ?? "/ro/list/jobs/irodai-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.name ?? "list-jobs-irodai-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.path ?? "/en/list/jobs/irodai-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47irodai_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/irodai-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.name ?? "list-jobs-it-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.path ?? "/list/jobs/it-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.name ?? "list-jobs-it-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.path ?? "/hu/list/jobs/it-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.name ?? "list-jobs-it-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.path ?? "/ro/list/jobs/it-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.name ?? "list-jobs-it-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.path ?? "/en/list/jobs/it-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.name ?? "list-jobs-it-fejlesztes",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.path ?? "/list/jobs/it-fejlesztes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.name ?? "list-jobs-it-fejlesztes___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.path ?? "/hu/list/jobs/it-fejlesztes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.name ?? "list-jobs-it-fejlesztes___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.path ?? "/ro/list/jobs/it-fejlesztes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.name ?? "list-jobs-it-fejlesztes___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.path ?? "/en/list/jobs/it-fejlesztes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45fejlesztes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-fejlesztes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.name ?? "list-jobs-it-poziciok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.path ?? "/list/jobs/it-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.name ?? "list-jobs-it-poziciok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.path ?? "/hu/list/jobs/it-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.name ?? "list-jobs-it-poziciok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.path ?? "/ro/list/jobs/it-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.name ?? "list-jobs-it-poziciok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.path ?? "/en/list/jobs/it-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.name ?? "list-jobs-it-uzemeltetes",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.path ?? "/list/jobs/it-uzemeltetes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.name ?? "list-jobs-it-uzemeltetes___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.path ?? "/hu/list/jobs/it-uzemeltetes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.name ?? "list-jobs-it-uzemeltetes___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.path ?? "/ro/list/jobs/it-uzemeltetes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.name ?? "list-jobs-it-uzemeltetes___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.path ?? "/en/list/jobs/it-uzemeltetes",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47it_45uzemeltetes_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/it-uzemeltetes.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.name ?? "list-jobs-marketinges-poziciok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.path ?? "/list/jobs/marketinges-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.name ?? "list-jobs-marketinges-poziciok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.path ?? "/hu/list/jobs/marketinges-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.name ?? "list-jobs-marketinges-poziciok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.path ?? "/ro/list/jobs/marketinges-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.name ?? "list-jobs-marketinges-poziciok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.path ?? "/en/list/jobs/marketinges-poziciok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47marketinges_45poziciok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/marketinges-poziciok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.name ?? "list-jobs-senior-it-allasok-egyeb-it-kategoriaban",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.path ?? "/list/jobs/senior-it-allasok-egyeb-it-kategoriaban",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.name ?? "list-jobs-senior-it-allasok-egyeb-it-kategoriaban___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.path ?? "/hu/list/jobs/senior-it-allasok-egyeb-it-kategoriaban",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.name ?? "list-jobs-senior-it-allasok-egyeb-it-kategoriaban___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.path ?? "/ro/list/jobs/senior-it-allasok-egyeb-it-kategoriaban",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.name ?? "list-jobs-senior-it-allasok-egyeb-it-kategoriaban___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.path ?? "/en/list/jobs/senior-it-allasok-egyeb-it-kategoriaban",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45allasok_45egyeb_45it_45kategoriaban_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-allasok-egyeb-it-kategoriaban.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-big-data-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.path ?? "/list/jobs/senior-it-big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-big-data-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.path ?? "/hu/list/jobs/senior-it-big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-big-data-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.path ?? "/ro/list/jobs/senior-it-big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-big-data-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.path ?? "/en/list/jobs/senior-it-big-data-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45big_45data_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-big-data-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-fejlesztoi-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.path ?? "/list/jobs/senior-it-fejlesztoi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-fejlesztoi-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.path ?? "/hu/list/jobs/senior-it-fejlesztoi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-fejlesztoi-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.path ?? "/ro/list/jobs/senior-it-fejlesztoi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-fejlesztoi-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.path ?? "/en/list/jobs/senior-it-fejlesztoi-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45fejlesztoi_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-fejlesztoi-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-uzemeltetes-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.path ?? "/list/jobs/senior-it-uzemeltetes-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-uzemeltetes-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.path ?? "/hu/list/jobs/senior-it-uzemeltetes-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-uzemeltetes-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.path ?? "/ro/list/jobs/senior-it-uzemeltetes-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.name ?? "list-jobs-senior-it-uzemeltetes-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.path ?? "/en/list/jobs/senior-it-uzemeltetes-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47senior_45it_45uzemeltetes_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/senior-it-uzemeltetes-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.name ?? "list-jobs-startup-allasok",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.path ?? "/list/jobs/startup-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.name ?? "list-jobs-startup-allasok___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.path ?? "/hu/list/jobs/startup-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.name ?? "list-jobs-startup-allasok___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.path ?? "/ro/list/jobs/startup-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.name ?? "list-jobs-startup-allasok___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.path ?? "/en/list/jobs/startup-allasok",
    file: "/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47list_47jobs_47startup_45allasok_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/list/jobs/startup-allasok.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.name ?? "locations",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.path ?? "/locations",
    file: "/home/forge/dreamjobs.hu/pages/locations.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/locations.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.name ?? "locations___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.path ?? "/hu/locations",
    file: "/home/forge/dreamjobs.hu/pages/locations.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/locations.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.name ?? "locations___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.path ?? "/ro/locations",
    file: "/home/forge/dreamjobs.hu/pages/locations.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/locations.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.name ?? "locations___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.path ?? "/en/locations",
    file: "/home/forge/dreamjobs.hu/pages/locations.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47locations_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/locations.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.name ?? "login",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.path ?? "/login",
    file: "/home/forge/dreamjobs.hu/pages/login/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.name ?? "login___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.path ?? "/hu/login",
    file: "/home/forge/dreamjobs.hu/pages/login/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.name ?? "login___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.path ?? "/ro/login",
    file: "/home/forge/dreamjobs.hu/pages/login/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.name ?? "login___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.path ?? "/en/login",
    file: "/home/forge/dreamjobs.hu/pages/login/index.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47index_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.name ?? "login-otp",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.path ?? "/login/otp",
    file: "/home/forge/dreamjobs.hu/pages/login/otp.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/otp.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.name ?? "login-otp___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.path ?? "/hu/login/otp",
    file: "/home/forge/dreamjobs.hu/pages/login/otp.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/otp.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.name ?? "login-otp___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.path ?? "/ro/login/otp",
    file: "/home/forge/dreamjobs.hu/pages/login/otp.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/otp.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.name ?? "login-otp___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.path ?? "/en/login/otp",
    file: "/home/forge/dreamjobs.hu/pages/login/otp.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47login_47otp_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/login/otp.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.name ?? "maintenance",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.path ?? "/maintenance",
    file: "/home/forge/dreamjobs.hu/pages/maintenance.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.name ?? "maintenance___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.path ?? "/hu/maintenance",
    file: "/home/forge/dreamjobs.hu/pages/maintenance.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.name ?? "maintenance___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.path ?? "/ro/maintenance",
    file: "/home/forge/dreamjobs.hu/pages/maintenance.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.name ?? "maintenance___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.path ?? "/en/maintenance",
    file: "/home/forge/dreamjobs.hu/pages/maintenance.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47maintenance_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.name ?? "my-applications",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.path ?? "/my-applications",
    file: "/home/forge/dreamjobs.hu/pages/my-applications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/my-applications.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.name ?? "my-applications___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.path ?? "/hu/my-applications",
    file: "/home/forge/dreamjobs.hu/pages/my-applications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/my-applications.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.name ?? "my-applications___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.path ?? "/ro/my-applications",
    file: "/home/forge/dreamjobs.hu/pages/my-applications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/my-applications.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.name ?? "my-applications___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.path ?? "/en/my-applications",
    file: "/home/forge/dreamjobs.hu/pages/my-applications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47my_45applications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/my-applications.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.name ?? "podcasts",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.path ?? "/podcasts",
    file: "/home/forge/dreamjobs.hu/pages/podcasts.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/podcasts.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.name ?? "podcasts___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.path ?? "/hu/podcasts",
    file: "/home/forge/dreamjobs.hu/pages/podcasts.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/podcasts.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.name ?? "podcasts___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.path ?? "/ro/podcasts",
    file: "/home/forge/dreamjobs.hu/pages/podcasts.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/podcasts.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.name ?? "podcasts___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.path ?? "/en/podcasts",
    file: "/home/forge/dreamjobs.hu/pages/podcasts.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47podcasts_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/podcasts.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.name ?? "premium-toborzas",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.path ?? "/premium-toborzas",
    file: "/home/forge/dreamjobs.hu/pages/premium-toborzas.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/premium-toborzas.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.name ?? "premium-toborzas___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.path ?? "/hu/premium-toborzas",
    file: "/home/forge/dreamjobs.hu/pages/premium-toborzas.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/premium-toborzas.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.name ?? "premium-toborzas___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.path ?? "/ro/premium-toborzas",
    file: "/home/forge/dreamjobs.hu/pages/premium-toborzas.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/premium-toborzas.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.name ?? "premium-toborzas___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.path ?? "/en/premium-toborzas",
    file: "/home/forge/dreamjobs.hu/pages/premium-toborzas.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47premium_45toborzas_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/premium-toborzas.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.name ?? "registration",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.path ?? "/registration",
    file: "/home/forge/dreamjobs.hu/pages/registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.name ?? "registration___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.path ?? "/hu/registration",
    file: "/home/forge/dreamjobs.hu/pages/registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.name ?? "registration___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.path ?? "/ro/registration",
    file: "/home/forge/dreamjobs.hu/pages/registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.name ?? "registration___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.path ?? "/en/registration",
    file: "/home/forge/dreamjobs.hu/pages/registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.name ?? "reset-password",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.path ?? "/reset-password",
    file: "/home/forge/dreamjobs.hu/pages/reset-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.name ?? "reset-password___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.path ?? "/hu/reset-password",
    file: "/home/forge/dreamjobs.hu/pages/reset-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.name ?? "reset-password___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.path ?? "/ro/reset-password",
    file: "/home/forge/dreamjobs.hu/pages/reset-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.name ?? "reset-password___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.path ?? "/en/reset-password",
    file: "/home/forge/dreamjobs.hu/pages/reset-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47reset_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.name ?? "salarycalculator",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.path ?? "/salarycalculator",
    file: "/home/forge/dreamjobs.hu/pages/salarycalculator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/salarycalculator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.name ?? "salarycalculator___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.path ?? "/hu/salarycalculator",
    file: "/home/forge/dreamjobs.hu/pages/salarycalculator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/salarycalculator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.name ?? "salarycalculator___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.path ?? "/ro/salarycalculator",
    file: "/home/forge/dreamjobs.hu/pages/salarycalculator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/salarycalculator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.name ?? "salarycalculator___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.path ?? "/en/salarycalculator",
    file: "/home/forge/dreamjobs.hu/pages/salarycalculator.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47salarycalculator_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/salarycalculator.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.name ?? "saved-jobs",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.path ?? "/saved-jobs",
    file: "/home/forge/dreamjobs.hu/pages/saved-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/saved-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.name ?? "saved-jobs___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.path ?? "/hu/saved-jobs",
    file: "/home/forge/dreamjobs.hu/pages/saved-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/saved-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.name ?? "saved-jobs___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.path ?? "/ro/saved-jobs",
    file: "/home/forge/dreamjobs.hu/pages/saved-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/saved-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.name ?? "saved-jobs___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.path ?? "/en/saved-jobs",
    file: "/home/forge/dreamjobs.hu/pages/saved-jobs.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47saved_45jobs_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/saved-jobs.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.name ?? "social-login-success",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.path ?? "/social-login-success",
    file: "/home/forge/dreamjobs.hu/pages/social-login-success.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-login-success.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.name ?? "social-login-success___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.path ?? "/hu/social-login-success",
    file: "/home/forge/dreamjobs.hu/pages/social-login-success.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-login-success.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.name ?? "social-login-success___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.path ?? "/ro/social-login-success",
    file: "/home/forge/dreamjobs.hu/pages/social-login-success.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-login-success.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.name ?? "social-login-success___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.path ?? "/en/social-login-success",
    file: "/home/forge/dreamjobs.hu/pages/social-login-success.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45login_45success_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-login-success.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.name ?? "social-registration",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.path ?? "/social-registration",
    file: "/home/forge/dreamjobs.hu/pages/social-registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.name ?? "social-registration___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.path ?? "/hu/social-registration",
    file: "/home/forge/dreamjobs.hu/pages/social-registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.name ?? "social-registration___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.path ?? "/ro/social-registration",
    file: "/home/forge/dreamjobs.hu/pages/social-registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.name ?? "social-registration___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.path ?? "/en/social-registration",
    file: "/home/forge/dreamjobs.hu/pages/social-registration.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47social_45registration_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/social-registration.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.name ?? "szmd-box-rating",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.path ?? "/szmd/box-rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.name ?? "szmd-box-rating___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.path ?? "/hu/szmd/box-rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.name ?? "szmd-box-rating___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.path ?? "/ro/szmd/box-rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.name ?? "szmd-box-rating___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.path ?? "/en/szmd/box-rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47box_45rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/box-rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.name ?? "szmd-rating",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.path ?? "/szmd/rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.name ?? "szmd-rating___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.path ?? "/hu/szmd/rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.name ?? "szmd-rating___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.path ?? "/ro/szmd/rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.name ?? "szmd-rating___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.path ?? "/en/szmd/rating",
    file: "/home/forge/dreamjobs.hu/pages/szmd/rating.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47szmd_47rating_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/szmd/rating.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.name ?? "unsubscribe",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.path ?? "/unsubscribe",
    file: "/home/forge/dreamjobs.hu/pages/unsubscribe.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.name ?? "unsubscribe___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.path ?? "/hu/unsubscribe",
    file: "/home/forge/dreamjobs.hu/pages/unsubscribe.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.name ?? "unsubscribe___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.path ?? "/ro/unsubscribe",
    file: "/home/forge/dreamjobs.hu/pages/unsubscribe.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.name ?? "unsubscribe___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.path ?? "/en/unsubscribe",
    file: "/home/forge/dreamjobs.hu/pages/unsubscribe.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47unsubscribe_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.name ?? "user-slug-profile",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.path ?? "/user/:slug/profile",
    file: "/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.name ?? "user-slug-profile___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.path ?? "/hu/user/:slug/profile",
    file: "/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.name ?? "user-slug-profile___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.path ?? "/ro/user/:slug/profile",
    file: "/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.name ?? "user-slug-profile___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.path ?? "/en/user/:slug/profile",
    file: "/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47_91slug_93_47profile_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/[slug]/profile.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.name ?? "user-account",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.path ?? "/user/account",
    file: "/home/forge/dreamjobs.hu/pages/user/account.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/account.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.name ?? "user-account___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.path ?? "/hu/user/account",
    file: "/home/forge/dreamjobs.hu/pages/user/account.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/account.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.name ?? "user-account___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.path ?? "/ro/user/account",
    file: "/home/forge/dreamjobs.hu/pages/user/account.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/account.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.name ?? "user-account___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.path ?? "/en/user/account",
    file: "/home/forge/dreamjobs.hu/pages/user/account.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47account_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/account.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.name ?? "user-change-password",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.path ?? "/user/change-password",
    file: "/home/forge/dreamjobs.hu/pages/user/change-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/change-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.name ?? "user-change-password___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.path ?? "/hu/user/change-password",
    file: "/home/forge/dreamjobs.hu/pages/user/change-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/change-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.name ?? "user-change-password___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.path ?? "/ro/user/change-password",
    file: "/home/forge/dreamjobs.hu/pages/user/change-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/change-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.name ?? "user-change-password___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.path ?? "/en/user/change-password",
    file: "/home/forge/dreamjobs.hu/pages/user/change-password.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47change_45password_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/change-password.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.name ?? "user-cv",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.path ?? "/user/cv",
    file: "/home/forge/dreamjobs.hu/pages/user/cv.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/cv.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.name ?? "user-cv___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.path ?? "/hu/user/cv",
    file: "/home/forge/dreamjobs.hu/pages/user/cv.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/cv.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.name ?? "user-cv___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.path ?? "/ro/user/cv",
    file: "/home/forge/dreamjobs.hu/pages/user/cv.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/cv.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.name ?? "user-cv___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.path ?? "/en/user/cv",
    file: "/home/forge/dreamjobs.hu/pages/user/cv.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47cv_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/cv.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.name ?? "user-linkedin",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.path ?? "/user/linkedin",
    file: "/home/forge/dreamjobs.hu/pages/user/linkedin.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/linkedin.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.name ?? "user-linkedin___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.path ?? "/hu/user/linkedin",
    file: "/home/forge/dreamjobs.hu/pages/user/linkedin.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/linkedin.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.name ?? "user-linkedin___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.path ?? "/ro/user/linkedin",
    file: "/home/forge/dreamjobs.hu/pages/user/linkedin.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/linkedin.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.name ?? "user-linkedin___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.path ?? "/en/user/linkedin",
    file: "/home/forge/dreamjobs.hu/pages/user/linkedin.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47linkedin_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/linkedin.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.name ?? "user-notifications",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.path ?? "/user/notifications",
    file: "/home/forge/dreamjobs.hu/pages/user/notifications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/notifications.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.name ?? "user-notifications___hu",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.path ?? "/hu/user/notifications",
    file: "/home/forge/dreamjobs.hu/pages/user/notifications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/notifications.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.name ?? "user-notifications___ro",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.path ?? "/ro/user/notifications",
    file: "/home/forge/dreamjobs.hu/pages/user/notifications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/notifications.vue").then(m => m.default || m)
  },
  {
    name: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.name ?? "user-notifications___en",
    path: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.path ?? "/en/user/notifications",
    file: "/home/forge/dreamjobs.hu/pages/user/notifications.vue",
    children: [],
    meta: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta,
    alias: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.alias || [],
    redirect: _47home_47forge_47dreamjobs_46hu_47pages_47user_47notifications_46vueMeta?.redirect || undefined,
    component: () => import("/home/forge/dreamjobs.hu/pages/user/notifications.vue").then(m => m.default || m)
  }
]